export const wrapperStyles = {
  scrollable: {
    "::-webkit-scrollbar": {
      width: "8px",
    },
    "::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "::-webkit-scrollbar-thumb": {
      background: "bg-muted",
    },
    scrollbar: {
      width: "8px",
    },
    scrollbarTrack: {
      background: "transparent",
    },
    scrollbarThumb: {
      background: "bg-muted",
    },
    scrollBehavior: "smooth",
    pb: {
      base: "112px",
    },
  },
};
